export default __webpack_public_path__ + "static/media/frame_2.03ebf9ed.jpg";